export const BINARY = 'binary';
export const MAX_KNOWLEDGE_MAP_NAME_LENGTH = 48;
export const MAX_KNOWLEDGE_MAP_SHORT_CODE = 32;
export const MAX_DESCRIPTION = 300;
export const MAX_ENABLING_OBJECTIVE_TITLE = 300;
export const MAX_LEARNING_OBJECTIVE_TITLE = 300;
export const KNOWLEDGE_MAP_PARENT_KEY = 'P';
export const KNOWLEDGE_MAP_CHILD_KEY = 'C';
